import React from "react";
import { Link } from "react-router-dom";

const title = "Oops! This Page Not Found";
const desc = "We are Really Sorry But the Page you Requested is Missing";

const ForeZeroPage = () => {
  return (
    <React.Fragment>
        <section className="fore-zero padding-tb">
          <div className="container">
            <div className="section-wrapper">
            <section className="whybat-section padding-tb bg-flower-img">
              <div className="container">

                  <div className="section-header">
                    <h2
                      data-description="title"
                      className="color-red-bat-home mt-20 responsive-title text-center"
                    >
                      404 Page Not Found
                    </h2>
                  </div>
                  <div className = "account-bottom1  text-center">
                    <button className="button login-btn create-btn text-white text-center">
                      <Link to="/">Go Back Home</Link>
                    </button>
                  </div>
              </div>
            </section>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default ForeZeroPage;
